var _circle, _path, _path2, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E62048"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2555 33C42.6952 41.7955 34.0722 48 24.0001 48C13.9279 48 5.30493 41.7955 1.74463 33H46.2555Z",
    fill: "#2B63D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2555 33C47.3805 30.2207 48 27.1827 48 24C48 20.8173 47.3805 17.7793 46.2555 15H1.74454C0.619507 17.7793 0 20.8173 0 24C0 27.1827 0.619507 30.2207 1.74454 33H46.2555Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgNl;